import { createContext } from "react";

const ANIMATIONS_ENABLED_DEFAULT_VALUE = true;

const LottieAnimationsEnabledContext = createContext(
  ANIMATIONS_ENABLED_DEFAULT_VALUE,
);

export { LottieAnimationsEnabledContext };
